/**
 * This file is auto-generated by scripts/generate-mappings.ts
 * Do not edit this file manually.
 */

export interface AccountInfo {
  name: string;
  writable: boolean;
  signer: boolean;
  optional: boolean;
  docs: string[];
  address?: string;
  pda?: {
    seeds: unknown[];
  };
}

export interface ExpectedAccount {
  name: string;
  pda: boolean;
}

export interface InstructionMapping {
  name: string;
  expectedAccounts: ExpectedAccount[];
  accounts: AccountInfo[];
  docs?: string;
  discriminator: number[];
  args: unknown[];
}

export const instructionAccountMappings: Record<string, InstructionMapping> = {
  "activate_agent": {
    "name": "activate_agent",
    "expectedAccounts": [
      {
        "name": "agent_account",
        "pda": true
      },
      {
        "name": "signer",
        "pda": false
      },
      {
        "name": "clock",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "agent_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent account with canonical PDA validation"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                97,
                103,
                101,
                110,
                116
              ]
            },
            {
              "kind": "account",
              "path": "signer"
            },
            {
              "kind": "arg",
              "path": "agent_id"
            }
          ]
        }
      },
      {
        "name": "signer",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": [
          "Enhanced authority verification"
        ]
      },
      {
        "name": "clock",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Clock sysvar for rate limiting"
        ],
        "address": "SysvarC1ock11111111111111111111111111111111"
      }
    ],
    "docs": "",
    "discriminator": [
      252,
      139,
      87,
      21,
      195,
      152,
      29,
      217
    ],
    "args": [
      {
        "name": "agent_id",
        "type": "string"
      }
    ]
  },
  "approve_delivery": {
    "name": "approve_delivery",
    "expectedAccounts": [
      {
        "name": "escrow",
        "pda": true
      },
      {
        "name": "escrow_vault",
        "pda": false
      },
      {
        "name": "agent_token_account",
        "pda": false
      },
      {
        "name": "client",
        "pda": false
      },
      {
        "name": "token_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "escrow",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                103,
                104,
                111,
                115,
                116,
                95,
                112,
                114,
                111,
                116,
                101,
                99,
                116
              ]
            },
            {
              "kind": "account",
              "path": "escrow.client",
              "account": "GhostProtectEscrow"
            },
            {
              "kind": "account",
              "path": "escrow.escrow_id",
              "account": "GhostProtectEscrow"
            }
          ]
        }
      },
      {
        "name": "escrow_vault",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "agent_token_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "client",
        "writable": false,
        "signer": true,
        "optional": false,
        "docs": []
      },
      {
        "name": "token_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
      }
    ],
    "docs": "Client approves delivery and releases payment",
    "discriminator": [
      28,
      233,
      51,
      115,
      33,
      220,
      41,
      28
    ],
    "args": []
  },
  "arbitrate_dispute": {
    "name": "arbitrate_dispute",
    "expectedAccounts": [
      {
        "name": "escrow",
        "pda": true
      },
      {
        "name": "escrow_vault",
        "pda": false
      },
      {
        "name": "agent_token_account",
        "pda": false
      },
      {
        "name": "client_token_account",
        "pda": false
      },
      {
        "name": "agent_staking",
        "pda": true
      },
      {
        "name": "arbitrator",
        "pda": false
      },
      {
        "name": "token_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "escrow",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                103,
                104,
                111,
                115,
                116,
                95,
                112,
                114,
                111,
                116,
                101,
                99,
                116
              ]
            },
            {
              "kind": "account",
              "path": "escrow.client",
              "account": "GhostProtectEscrow"
            },
            {
              "kind": "account",
              "path": "escrow.escrow_id",
              "account": "GhostProtectEscrow"
            }
          ]
        }
      },
      {
        "name": "escrow_vault",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "agent_token_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "client_token_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "agent_staking",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent's staking account (for potential slashing)"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                115,
                116,
                97,
                107,
                105,
                110,
                103
              ]
            },
            {
              "kind": "account",
              "path": "escrow.agent",
              "account": "GhostProtectEscrow"
            }
          ]
        }
      },
      {
        "name": "arbitrator",
        "writable": false,
        "signer": true,
        "optional": false,
        "docs": []
      },
      {
        "name": "token_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
      }
    ],
    "docs": "Arbitrator resolves dispute (admin only)",
    "discriminator": [
      225,
      89,
      166,
      101,
      215,
      40,
      191,
      4
    ],
    "args": [
      {
        "name": "decision",
        "type": {
          "defined": {
            "name": "ArbitratorDecision"
          }
        }
      }
    ]
  },
  "auto_create_ghost": {
    "name": "auto_create_ghost",
    "expectedAccounts": [
      {
        "name": "agent_account",
        "pda": true
      },
      {
        "name": "authority",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "agent_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                97,
                103,
                101,
                110,
                116
              ]
            },
            {
              "kind": "arg",
              "path": "payment_address"
            }
          ]
        }
      },
      {
        "name": "authority",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "11111111111111111111111111111111"
      }
    ],
    "docs": "Auto-create a Ghost from discovered x402 transaction (indexer service only)  Used by the off-chain indexer service when it discovers a new agent via x402 payment transactions. Creates an Unregistered Ghost.  Parameters: - payment_address: The x402_payment_address (merchant address) of the discovered agent - first_tx_signature: Transaction signature where this agent was first discovered - discovery_source: Source identifier (e.g., \"http:payai\", \"blockchain:direct\") - initial_ghost_score: Optional initial Ghost Score from backfill metrics",
    "discriminator": [
      50,
      170,
      232,
      73,
      238,
      200,
      180,
      16
    ],
    "args": [
      {
        "name": "payment_address",
        "type": "pubkey"
      },
      {
        "name": "first_tx_signature",
        "type": "string"
      },
      {
        "name": "discovery_source",
        "type": "string"
      },
      {
        "name": "initial_ghost_score",
        "type": {
          "option": "u64"
        }
      }
    ]
  },
  "claim_ghost": {
    "name": "claim_ghost",
    "expectedAccounts": [
      {
        "name": "agent_account",
        "pda": false
      },
      {
        "name": "did_document",
        "pda": true
      },
      {
        "name": "sas_attestation",
        "pda": false
      },
      {
        "name": "claimer",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "agent_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "did_document",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "DID document to create for this Ghost",
          "Seeds: [b\"did_document\", agent_account.x402_payment_address.as_ref()]"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                100,
                105,
                100,
                95,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116
              ]
            },
            {
              "kind": "account",
              "path": "agent_account.x402_payment_address",
              "account": "Agent"
            }
          ]
        }
      },
      {
        "name": "sas_attestation",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "SAS Attestation proving ownership of x402_payment_address",
          "PDA: [b\"attestation\", sas_credential, sas_schema, x402_payment_address]"
        ]
      },
      {
        "name": "claimer",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": [
          "The claimer must have created a SAS attestation proving they own x402_payment_address"
        ]
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "11111111111111111111111111111111"
      }
    ],
    "docs": "Claim ownership of a Ghost using Solana Attestation Service (SAS)  Security: Uses SAS for trustless ownership verification. The claimer must have created a SAS attestation proving they own the x402_payment_address.  Auto-creates: DID document with did:sol:<network>:<address> format Transitions: Unregistered/Registered → Claimed  SAS Attestation Requirements: - Credential: GhostSpeak ownership credential (issuer) - Schema: Ghost ownership schema defining attestation data structure - Nonce: x402_payment_address (ensures PDA uniqueness) - Data: Contains x402_payment_address as proof of ownership  Parameters: - sas_credential: Pubkey of the SAS Credential (issuer) for ownership attestations - sas_schema: Pubkey of the SAS Schema defining the ownership attestation format - ipfs_metadata_uri: Optional IPFS URI for agent metadata (ipfs://...) - network: Network identifier (\"devnet\", \"mainnet-beta\", \"testnet\")",
    "discriminator": [
      149,
      107,
      35,
      233,
      252,
      101,
      148,
      225
    ],
    "args": [
      {
        "name": "sas_credential",
        "type": "pubkey"
      },
      {
        "name": "sas_schema",
        "type": "pubkey"
      },
      {
        "name": "ipfs_metadata_uri",
        "type": {
          "option": "string"
        }
      },
      {
        "name": "network",
        "type": "string"
      }
    ]
  },
  "create_agent_authorization": {
    "name": "create_agent_authorization",
    "expectedAccounts": [
      {
        "name": "agent",
        "pda": false
      },
      {
        "name": "authorization",
        "pda": true
      },
      {
        "name": "authority",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "agent",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent granting authorization"
        ]
      },
      {
        "name": "authorization",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Authorization account (PDA)"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                97,
                103,
                101,
                110,
                116,
                95,
                97,
                117,
                116,
                104
              ]
            },
            {
              "kind": "account",
              "path": "agent"
            },
            {
              "kind": "arg",
              "path": "authorized_source"
            },
            {
              "kind": "arg",
              "path": "nonce"
            }
          ]
        }
      },
      {
        "name": "authority",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": [
          "Authority (agent owner)"
        ]
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "System program"
        ],
        "address": "11111111111111111111111111111111"
      }
    ],
    "docs": "Create agent authorization for reputation updates  Allows an agent to pre-authorize a facilitator (e.g., PayAI) to update their reputation a limited number of times before expiration.  Parameters: - authorized_source: Pubkey of the facilitator being authorized - index_limit: Maximum number of updates allowed - expires_at: Unix timestamp when authorization expires - network: Network ID for cross-chain compatibility - signature: Ed25519 signature proving agent's consent - nonce: Optional nonce for multiple authorizations to same facilitator",
    "discriminator": [
      48,
      219,
      232,
      202,
      151,
      97,
      230,
      20
    ],
    "args": [
      {
        "name": "authorized_source",
        "type": "pubkey"
      },
      {
        "name": "index_limit",
        "type": "u64"
      },
      {
        "name": "expires_at",
        "type": "i64"
      },
      {
        "name": "network",
        "type": "u8"
      },
      {
        "name": "signature",
        "type": {
          "array": [
            "u8",
            64
          ]
        }
      },
      {
        "name": "nonce",
        "type": {
          "option": "string"
        }
      }
    ]
  },
  "create_credential_template": {
    "name": "create_credential_template",
    "expectedAccounts": [
      {
        "name": "credential_template",
        "pda": true
      },
      {
        "name": "credential_type",
        "pda": false
      },
      {
        "name": "issuer",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "credential_template",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                99,
                114,
                101,
                100,
                101,
                110,
                116,
                105,
                97,
                108,
                95,
                116,
                101,
                109,
                112,
                108,
                97,
                116,
                101
              ]
            },
            {
              "kind": "account",
              "path": "credential_type"
            },
            {
              "kind": "arg",
              "path": "name"
            }
          ]
        }
      },
      {
        "name": "credential_type",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "issuer",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "11111111111111111111111111111111"
      }
    ],
    "docs": "Create a credential template from a credential type for issuing credentials",
    "discriminator": [
      183,
      109,
      12,
      128,
      134,
      8,
      139,
      144
    ],
    "args": [
      {
        "name": "name",
        "type": "string"
      },
      {
        "name": "image_uri",
        "type": "string"
      },
      {
        "name": "crossmint_template_id",
        "type": {
          "option": "string"
        }
      }
    ]
  },
  "create_credential_type": {
    "name": "create_credential_type",
    "expectedAccounts": [
      {
        "name": "credential_type",
        "pda": true
      },
      {
        "name": "authority",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "credential_type",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                99,
                114,
                101,
                100,
                101,
                110,
                116,
                105,
                97,
                108,
                95,
                116,
                121,
                112,
                101
              ]
            },
            {
              "kind": "arg",
              "path": "name"
            }
          ]
        }
      },
      {
        "name": "authority",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "11111111111111111111111111111111"
      }
    ],
    "docs": "Create a new credential type (e.g., AgentIdentity, Reputation, JobCompletion) This is an admin-only operation typically done by governance/multisig.",
    "discriminator": [
      211,
      208,
      67,
      175,
      20,
      248,
      8,
      227
    ],
    "args": [
      {
        "name": "name",
        "type": "string"
      },
      {
        "name": "kind",
        "type": {
          "defined": {
            "name": "CredentialKind"
          }
        }
      },
      {
        "name": "schema_uri",
        "type": "string"
      },
      {
        "name": "description",
        "type": "string"
      }
    ]
  },
  "create_did_document": {
    "name": "create_did_document",
    "expectedAccounts": [
      {
        "name": "did_document",
        "pda": true
      },
      {
        "name": "controller",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      },
      {
        "name": "clock",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "did_document",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "DID document account with canonical PDA"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                100,
                105,
                100,
                95,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116
              ]
            },
            {
              "kind": "account",
              "path": "controller"
            }
          ]
        }
      },
      {
        "name": "controller",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": [
          "Controller of the DID (owner)"
        ]
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "System program for account creation"
        ],
        "address": "11111111111111111111111111111111"
      },
      {
        "name": "clock",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Clock sysvar for timestamp validation"
        ],
        "address": "SysvarC1ock11111111111111111111111111111111"
      }
    ],
    "docs": "Create a new DID document for an agent or user  Initializes a W3C-compliant DID document following the did:sol method. The DID document can contain verification methods and service endpoints.  Parameters: - did_string: The DID string (e.g., \"did:sol:devnet:HN7c...\") - verification_methods: Initial verification methods (max 10) - service_endpoints: Initial service endpoints (max 5)",
    "discriminator": [
      253,
      40,
      200,
      239,
      69,
      147,
      82,
      182
    ],
    "args": [
      {
        "name": "did_string",
        "type": "string"
      },
      {
        "name": "verification_methods",
        "type": {
          "vec": {
            "defined": {
              "name": "VerificationMethod"
            }
          }
        }
      },
      {
        "name": "service_endpoints",
        "type": {
          "vec": {
            "defined": {
              "name": "ServiceEndpoint"
            }
          }
        }
      }
    ]
  },
  "create_escrow": {
    "name": "create_escrow",
    "expectedAccounts": [
      {
        "name": "escrow",
        "pda": true
      },
      {
        "name": "agent",
        "pda": false
      },
      {
        "name": "client_token_account",
        "pda": false
      },
      {
        "name": "escrow_vault",
        "pda": false
      },
      {
        "name": "token_mint",
        "pda": false
      },
      {
        "name": "client",
        "pda": false
      },
      {
        "name": "token_program",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "escrow",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                103,
                104,
                111,
                115,
                116,
                95,
                112,
                114,
                111,
                116,
                101,
                99,
                116
              ]
            },
            {
              "kind": "account",
              "path": "client"
            },
            {
              "kind": "arg",
              "path": "escrow_id"
            }
          ]
        }
      },
      {
        "name": "agent",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "client_token_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "escrow_vault",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "token_mint",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "client",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      },
      {
        "name": "token_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "11111111111111111111111111111111"
      }
    ],
    "docs": "Create a new escrow for agent service payment",
    "discriminator": [
      253,
      215,
      165,
      116,
      36,
      108,
      68,
      80
    ],
    "args": [
      {
        "name": "escrow_id",
        "type": "u64"
      },
      {
        "name": "amount",
        "type": "u64"
      },
      {
        "name": "job_description",
        "type": "string"
      },
      {
        "name": "deadline",
        "type": "i64"
      }
    ]
  },
  "create_multisig": {
    "name": "create_multisig",
    "expectedAccounts": [
      {
        "name": "multisig",
        "pda": true
      },
      {
        "name": "owner",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "multisig",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                109,
                117,
                108,
                116,
                105,
                115,
                105,
                103
              ]
            },
            {
              "kind": "account",
              "path": "owner"
            },
            {
              "kind": "arg",
              "path": "multisig_id"
            }
          ]
        }
      },
      {
        "name": "owner",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "11111111111111111111111111111111"
      }
    ],
    "docs": "",
    "discriminator": [
      148,
      146,
      240,
      10,
      226,
      215,
      167,
      174
    ],
    "args": [
      {
        "name": "multisig_id",
        "type": "u64"
      },
      {
        "name": "threshold",
        "type": "u8"
      },
      {
        "name": "signers",
        "type": {
          "vec": "pubkey"
        }
      },
      {
        "name": "config",
        "type": {
          "defined": {
            "name": "MultisigConfig"
          }
        }
      }
    ]
  },
  "deactivate_agent": {
    "name": "deactivate_agent",
    "expectedAccounts": [
      {
        "name": "agent_account",
        "pda": true
      },
      {
        "name": "signer",
        "pda": false
      },
      {
        "name": "clock",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "agent_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent account with canonical PDA validation"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                97,
                103,
                101,
                110,
                116
              ]
            },
            {
              "kind": "account",
              "path": "signer"
            },
            {
              "kind": "arg",
              "path": "agent_id"
            }
          ]
        }
      },
      {
        "name": "signer",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": [
          "Enhanced authority verification"
        ]
      },
      {
        "name": "clock",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Clock sysvar for rate limiting"
        ],
        "address": "SysvarC1ock11111111111111111111111111111111"
      }
    ],
    "docs": "",
    "discriminator": [
      205,
      171,
      239,
      225,
      82,
      126,
      96,
      166
    ],
    "args": [
      {
        "name": "agent_id",
        "type": "string"
      }
    ]
  },
  "deactivate_credential_template": {
    "name": "deactivate_credential_template",
    "expectedAccounts": [
      {
        "name": "credential_template",
        "pda": false
      },
      {
        "name": "issuer",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "credential_template",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "issuer",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      }
    ],
    "docs": "Deactivate a credential template (no new credentials can be issued from it)",
    "discriminator": [
      177,
      8,
      195,
      104,
      56,
      34,
      84,
      162
    ],
    "args": []
  },
  "deactivate_credential_type": {
    "name": "deactivate_credential_type",
    "expectedAccounts": [
      {
        "name": "credential_type",
        "pda": false
      },
      {
        "name": "authority",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "credential_type",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "authority",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      }
    ],
    "docs": "Deactivate a credential type (no new credentials can be issued)",
    "discriminator": [
      110,
      174,
      221,
      244,
      36,
      206,
      60,
      237
    ],
    "args": []
  },
  "deactivate_did_document": {
    "name": "deactivate_did_document",
    "expectedAccounts": [
      {
        "name": "did_document",
        "pda": true
      },
      {
        "name": "controller",
        "pda": false
      },
      {
        "name": "clock",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "did_document",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "DID document account with canonical PDA validation"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                100,
                105,
                100,
                95,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116
              ]
            },
            {
              "kind": "account",
              "path": "controller"
            }
          ]
        }
      },
      {
        "name": "controller",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": [
          "Controller of the DID (must match document controller)"
        ]
      },
      {
        "name": "clock",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Clock sysvar for timestamp validation"
        ],
        "address": "SysvarC1ock11111111111111111111111111111111"
      }
    ],
    "docs": "Deactivate a DID document  Permanently deactivates the DID document. This operation is irreversible. Only the controller can deactivate their DID.",
    "discriminator": [
      77,
      13,
      56,
      161,
      67,
      155,
      206,
      119
    ],
    "args": []
  },
  "enable_protocol_fees": {
    "name": "enable_protocol_fees",
    "expectedAccounts": [
      {
        "name": "config",
        "pda": true
      },
      {
        "name": "authority",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "config",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                112,
                114,
                111,
                116,
                111,
                99,
                111,
                108,
                95,
                99,
                111,
                110,
                102,
                105,
                103
              ]
            }
          ]
        }
      },
      {
        "name": "authority",
        "writable": false,
        "signer": true,
        "optional": false,
        "docs": []
      }
    ],
    "docs": "Enable production fees (authority only)  Activates the full fee structure for mainnet: - Escrow: 0.5% (80% Treasury, 20% Buyback) - Agent Registration: 0.01 SOL - Marketplace Listing: 0.001 SOL - Dispute Resolution: 1%",
    "discriminator": [
      9,
      115,
      79,
      19,
      158,
      209,
      221,
      38
    ],
    "args": []
  },
  "file_dispute": {
    "name": "file_dispute",
    "expectedAccounts": [
      {
        "name": "escrow",
        "pda": true
      },
      {
        "name": "client",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "escrow",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                103,
                104,
                111,
                115,
                116,
                95,
                112,
                114,
                111,
                116,
                101,
                99,
                116
              ]
            },
            {
              "kind": "account",
              "path": "escrow.client",
              "account": "GhostProtectEscrow"
            },
            {
              "kind": "account",
              "path": "escrow.escrow_id",
              "account": "GhostProtectEscrow"
            }
          ]
        }
      },
      {
        "name": "client",
        "writable": false,
        "signer": true,
        "optional": false,
        "docs": []
      }
    ],
    "docs": "Client files a dispute on escrow",
    "discriminator": [
      210,
      63,
      221,
      114,
      212,
      97,
      195,
      156
    ],
    "args": [
      {
        "name": "reason",
        "type": "string"
      }
    ]
  },
  "generate_compliance_report": {
    "name": "generate_compliance_report",
    "expectedAccounts": [
      {
        "name": "report",
        "pda": true
      },
      {
        "name": "audit_trail",
        "pda": false
      },
      {
        "name": "authority",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "report",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                99,
                111,
                109,
                112,
                108,
                105,
                97,
                110,
                99,
                101,
                95,
                114,
                101,
                112,
                111,
                114,
                116
              ]
            },
            {
              "kind": "arg",
              "path": "report_id"
            }
          ]
        }
      },
      {
        "name": "audit_trail",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Audit trail for the entity"
        ]
      },
      {
        "name": "authority",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "11111111111111111111111111111111"
      }
    ],
    "docs": "",
    "discriminator": [
      213,
      97,
      79,
      234,
      22,
      228,
      14,
      32
    ],
    "args": [
      {
        "name": "report_id",
        "type": "u64"
      },
      {
        "name": "report_type",
        "type": {
          "defined": {
            "name": "ReportType"
          }
        }
      },
      {
        "name": "date_range_start",
        "type": "i64"
      },
      {
        "name": "date_range_end",
        "type": "i64"
      }
    ]
  },
  "init_reentrancy_guard": {
    "name": "init_reentrancy_guard",
    "expectedAccounts": [
      {
        "name": "reentrancy_guard",
        "pda": true
      },
      {
        "name": "authority",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "reentrancy_guard",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                114,
                101,
                101,
                110,
                116,
                114,
                97,
                110,
                99,
                121,
                95,
                103,
                117,
                97,
                114,
                100
              ]
            }
          ]
        }
      },
      {
        "name": "authority",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "11111111111111111111111111111111"
      }
    ],
    "docs": "Initialize the global reentrancy guard PDA This must be called once by a program admin before any reentrancy-protected instructions can be used",
    "discriminator": [
      156,
      109,
      115,
      85,
      12,
      60,
      245,
      99
    ],
    "args": []
  },
  "initialize_audit_trail": {
    "name": "initialize_audit_trail",
    "expectedAccounts": [
      {
        "name": "audit_trail",
        "pda": true
      },
      {
        "name": "entity",
        "pda": false
      },
      {
        "name": "authority",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "audit_trail",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                97,
                117,
                100,
                105,
                116,
                95,
                116,
                114,
                97,
                105,
                108
              ]
            },
            {
              "kind": "account",
              "path": "entity"
            }
          ]
        }
      },
      {
        "name": "entity",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Entity being audited"
        ]
      },
      {
        "name": "authority",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "11111111111111111111111111111111"
      }
    ],
    "docs": "",
    "discriminator": [
      145,
      182,
      236,
      249,
      212,
      17,
      175,
      161
    ],
    "args": [
      {
        "name": "entity_type",
        "type": "string"
      },
      {
        "name": "config",
        "type": {
          "defined": {
            "name": "AuditConfig"
          }
        }
      }
    ]
  },
  "initialize_governance_proposal": {
    "name": "initialize_governance_proposal",
    "expectedAccounts": [
      {
        "name": "proposal",
        "pda": true
      },
      {
        "name": "proposer",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "proposal",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                103,
                111,
                118,
                101,
                114,
                110,
                97,
                110,
                99,
                101,
                95,
                112,
                114,
                111,
                112,
                111,
                115,
                97,
                108
              ]
            },
            {
              "kind": "arg",
              "path": "proposal_id"
            }
          ]
        }
      },
      {
        "name": "proposer",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "11111111111111111111111111111111"
      }
    ],
    "docs": "",
    "discriminator": [
      137,
      84,
      234,
      206,
      17,
      58,
      54,
      215
    ],
    "args": [
      {
        "name": "proposal_id",
        "type": "u64"
      },
      {
        "name": "title",
        "type": "string"
      },
      {
        "name": "description",
        "type": "string"
      },
      {
        "name": "proposal_type",
        "type": {
          "defined": {
            "name": "ProposalType"
          }
        }
      },
      {
        "name": "execution_params",
        "type": {
          "defined": {
            "name": "ExecutionParams"
          }
        }
      }
    ]
  },
  "initialize_protocol_config": {
    "name": "initialize_protocol_config",
    "expectedAccounts": [
      {
        "name": "config",
        "pda": true
      },
      {
        "name": "authority",
        "pda": false
      },
      {
        "name": "treasury",
        "pda": false
      },
      {
        "name": "buyback_pool",
        "pda": false
      },
      {
        "name": "moderator_pool",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "config",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                112,
                114,
                111,
                116,
                111,
                99,
                111,
                108,
                95,
                99,
                111,
                110,
                102,
                105,
                103
              ]
            }
          ]
        }
      },
      {
        "name": "authority",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": [
          "Authority who will control the config (typically DAO or multisig)"
        ]
      },
      {
        "name": "treasury",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Treasury wallet to receive protocol fees"
        ]
      },
      {
        "name": "buyback_pool",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Buyback pool wallet for token buybacks"
        ]
      },
      {
        "name": "moderator_pool",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Moderator pool for dispute fees"
        ]
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "11111111111111111111111111111111"
      }
    ],
    "docs": "Initialize the global protocol configuration  Sets up fee infrastructure with all fees initially disabled (set to 0). Fees will be enabled via governance after mainnet deployment.  NOTE: Fee structure is in place but set to 0 until mainnet.",
    "discriminator": [
      28,
      50,
      43,
      233,
      244,
      98,
      123,
      118
    ],
    "args": []
  },
  "initialize_rbac_config": {
    "name": "initialize_rbac_config",
    "expectedAccounts": [
      {
        "name": "rbac_config",
        "pda": true
      },
      {
        "name": "authority",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "rbac_config",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                114,
                98,
                97,
                99,
                95,
                99,
                111,
                110,
                102,
                105,
                103
              ]
            },
            {
              "kind": "account",
              "path": "authority"
            }
          ]
        }
      },
      {
        "name": "authority",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "11111111111111111111111111111111"
      }
    ],
    "docs": "",
    "discriminator": [
      215,
      68,
      129,
      228,
      237,
      165,
      0,
      240
    ],
    "args": [
      {
        "name": "initial_roles",
        "type": {
          "vec": {
            "defined": {
              "name": "Role"
            }
          }
        }
      }
    ]
  },
  "initialize_reputation_metrics": {
    "name": "initialize_reputation_metrics",
    "expectedAccounts": [
      {
        "name": "reputation_metrics",
        "pda": true
      },
      {
        "name": "agent",
        "pda": false
      },
      {
        "name": "authority",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      },
      {
        "name": "clock",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "reputation_metrics",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Reputation metrics account"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                114,
                101,
                112,
                117,
                116,
                97,
                116,
                105,
                111,
                110,
                95,
                109,
                101,
                116,
                114,
                105,
                99,
                115
              ]
            },
            {
              "kind": "account",
              "path": "agent"
            }
          ]
        }
      },
      {
        "name": "agent",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent account"
        ]
      },
      {
        "name": "authority",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": [
          "Authority (agent owner)"
        ]
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "System program"
        ],
        "address": "11111111111111111111111111111111"
      },
      {
        "name": "clock",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Clock for timestamps"
        ],
        "address": "SysvarC1ock11111111111111111111111111111111"
      }
    ],
    "docs": "Initialize reputation metrics for an agent  Creates a new reputation tracking account that monitors: - Payment success/failure rates - Service ratings from clients - Response time performance - Dispute resolution history",
    "discriminator": [
      228,
      11,
      207,
      44,
      52,
      188,
      169,
      237
    ],
    "args": []
  },
  "initialize_staking_config": {
    "name": "initialize_staking_config",
    "expectedAccounts": [
      {
        "name": "staking_config",
        "pda": true
      },
      {
        "name": "authority",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "staking_config",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                115,
                116,
                97,
                107,
                105,
                110,
                103,
                95,
                99,
                111,
                110,
                102,
                105,
                103
              ]
            }
          ]
        }
      },
      {
        "name": "authority",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "11111111111111111111111111111111"
      }
    ],
    "docs": "Initialize GHOST token staking configuration (admin only)",
    "discriminator": [
      78,
      164,
      6,
      115,
      206,
      48,
      168,
      105
    ],
    "args": [
      {
        "name": "min_stake",
        "type": "u64"
      },
      {
        "name": "treasury",
        "type": "pubkey"
      }
    ]
  },
  "issue_credential": {
    "name": "issue_credential",
    "expectedAccounts": [
      {
        "name": "credential",
        "pda": true
      },
      {
        "name": "credential_template",
        "pda": false
      },
      {
        "name": "credential_type",
        "pda": false
      },
      {
        "name": "subject",
        "pda": false
      },
      {
        "name": "issuer",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "credential",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                99,
                114,
                101,
                100,
                101,
                110,
                116,
                105,
                97,
                108
              ]
            },
            {
              "kind": "account",
              "path": "credential_template"
            },
            {
              "kind": "account",
              "path": "subject"
            },
            {
              "kind": "arg",
              "path": "credential_id"
            }
          ]
        }
      },
      {
        "name": "credential_template",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "credential_type",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "subject",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "issuer",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "11111111111111111111111111111111"
      }
    ],
    "docs": "Issue a new credential to a subject The subject_data is stored off-chain; only the hash is stored on-chain.",
    "discriminator": [
      255,
      193,
      171,
      224,
      68,
      171,
      194,
      87
    ],
    "args": [
      {
        "name": "credential_id",
        "type": "string"
      },
      {
        "name": "subject_data_hash",
        "type": {
          "array": [
            "u8",
            32
          ]
        }
      },
      {
        "name": "subject_data_uri",
        "type": "string"
      },
      {
        "name": "expires_at",
        "type": {
          "option": "i64"
        }
      },
      {
        "name": "source_account",
        "type": {
          "option": "pubkey"
        }
      }
    ]
  },
  "link_external_id": {
    "name": "link_external_id",
    "expectedAccounts": [
      {
        "name": "agent_account",
        "pda": false
      },
      {
        "name": "external_id_mapping",
        "pda": true
      },
      {
        "name": "authority",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "agent_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "external_id_mapping",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                101,
                120,
                116,
                101,
                114,
                110,
                97,
                108,
                95,
                105,
                100
              ]
            },
            {
              "kind": "arg",
              "path": "platform"
            },
            {
              "kind": "arg",
              "path": "external_id"
            }
          ]
        }
      },
      {
        "name": "authority",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "11111111111111111111111111111111"
      }
    ],
    "docs": "Link a platform-specific external ID to a Ghost  Creates a cross-platform identity mapping for this Ghost. Only the Ghost owner can link external IDs.  Parameters: - platform: Platform identifier (e.g., \"payai\", \"eliza\", \"github\") (max 32 chars) - external_id: Platform-specific agent ID (max 128 chars) - verified: Whether this external ID has been verified",
    "discriminator": [
      156,
      102,
      141,
      155,
      175,
      13,
      29,
      86
    ],
    "args": [
      {
        "name": "platform",
        "type": "string"
      },
      {
        "name": "external_id",
        "type": "string"
      },
      {
        "name": "verified",
        "type": "bool"
      }
    ]
  },
  "manage_agent_status": {
    "name": "manage_agent_status",
    "expectedAccounts": [
      {
        "name": "agent",
        "pda": true
      },
      {
        "name": "owner",
        "pda": false
      },
      {
        "name": "clock",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "agent",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent account with strict validation"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                97,
                103,
                101,
                110,
                116
              ]
            },
            {
              "kind": "account",
              "path": "owner"
            }
          ]
        }
      },
      {
        "name": "owner",
        "writable": false,
        "signer": true,
        "optional": false,
        "docs": [
          "Owner authority"
        ]
      },
      {
        "name": "clock",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Clock sysvar for timestamp validation"
        ],
        "address": "SysvarC1ock11111111111111111111111111111111"
      }
    ],
    "docs": "",
    "discriminator": [
      164,
      219,
      91,
      38,
      45,
      31,
      33,
      47
    ],
    "args": [
      {
        "name": "new_status",
        "type": "bool"
      }
    ]
  },
  "record_payai_payment": {
    "name": "record_payai_payment",
    "expectedAccounts": [
      {
        "name": "reputation_metrics",
        "pda": true
      },
      {
        "name": "agent",
        "pda": false
      },
      {
        "name": "authority",
        "pda": false
      },
      {
        "name": "clock",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "reputation_metrics",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Reputation metrics account"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                114,
                101,
                112,
                117,
                116,
                97,
                116,
                105,
                111,
                110,
                95,
                109,
                101,
                116,
                114,
                105,
                99,
                115
              ]
            },
            {
              "kind": "account",
              "path": "agent"
            }
          ]
        }
      },
      {
        "name": "agent",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent account"
        ]
      },
      {
        "name": "authority",
        "writable": false,
        "signer": true,
        "optional": false,
        "docs": [
          "Authority (can be the payment verifier or agent owner)"
        ]
      },
      {
        "name": "clock",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Clock for timestamps"
        ],
        "address": "SysvarC1ock11111111111111111111111111111111"
      }
    ],
    "docs": "Record a PayAI payment transaction for reputation tracking  Consumes payment data from PayAI protocol to update agent reputation. This does NOT facilitate payments - it only tracks them for reputation.  Parameters: - payment_signature: PayAI transaction signature - amount: Payment amount in lamports - response_time_ms: Service response time - success: Whether payment completed successfully",
    "discriminator": [
      165,
      202,
      159,
      139,
      65,
      65,
      36,
      163
    ],
    "args": [
      {
        "name": "payment_signature",
        "type": "string"
      },
      {
        "name": "amount",
        "type": "u64"
      },
      {
        "name": "response_time_ms",
        "type": "u64"
      },
      {
        "name": "success",
        "type": "bool"
      }
    ]
  },
  "register_agent": {
    "name": "register_agent",
    "expectedAccounts": [
      {
        "name": "agent_account",
        "pda": true
      },
      {
        "name": "staking_account",
        "pda": true
      },
      {
        "name": "signer",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      },
      {
        "name": "clock",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "agent_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent account with enhanced 2025 PDA security"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                97,
                103,
                101,
                110,
                116
              ]
            },
            {
              "kind": "account",
              "path": "signer"
            },
            {
              "kind": "arg",
              "path": "agent_id"
            }
          ]
        }
      },
      {
        "name": "staking_account",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Staking account - REQUIRED for Sybil resistance (must have >= 1K GHOST staked)"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                115,
                116,
                97,
                107,
                105,
                110,
                103
              ]
            },
            {
              "kind": "account",
              "path": "signer"
            }
          ]
        }
      },
      {
        "name": "signer",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": [
          "User registry with enhanced validation",
          "Authority with enhanced verification"
        ]
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "System program for account creation"
        ],
        "address": "11111111111111111111111111111111"
      },
      {
        "name": "clock",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Clock sysvar for timestamp validation"
        ],
        "address": "SysvarC1ock11111111111111111111111111111111"
      }
    ],
    "docs": "",
    "discriminator": [
      135,
      157,
      66,
      195,
      2,
      113,
      175,
      30
    ],
    "args": [
      {
        "name": "agent_type",
        "type": "u8"
      },
      {
        "name": "name",
        "type": "string"
      },
      {
        "name": "description",
        "type": "string"
      },
      {
        "name": "metadata_uri",
        "type": "string"
      },
      {
        "name": "_agent_id",
        "type": "string"
      },
      {
        "name": "pricing_model",
        "type": {
          "defined": {
            "name": "PricingModel"
          }
        }
      }
    ]
  },
  "register_agent_compressed": {
    "name": "register_agent_compressed",
    "expectedAccounts": [
      {
        "name": "tree_authority",
        "pda": true
      },
      {
        "name": "merkle_tree",
        "pda": false
      },
      {
        "name": "user_registry",
        "pda": true
      },
      {
        "name": "signer",
        "pda": false
      },
      {
        "name": "compression_program",
        "pda": false
      },
      {
        "name": "log_wrapper",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      },
      {
        "name": "clock",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "tree_authority",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Tree authority PDA that manages the compressed Agent tree"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                97,
                103,
                101,
                110,
                116,
                95,
                116,
                114,
                101,
                101,
                95,
                99,
                111,
                110,
                102,
                105,
                103
              ]
            },
            {
              "kind": "account",
              "path": "signer"
            }
          ]
        }
      },
      {
        "name": "merkle_tree",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "The Merkle tree account that stores compressed Agent data"
        ]
      },
      {
        "name": "user_registry",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "User registry with enhanced validation"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                117,
                115,
                101,
                114,
                95,
                114,
                101,
                103,
                105,
                115,
                116,
                114,
                121
              ]
            },
            {
              "kind": "account",
              "path": "signer"
            }
          ]
        }
      },
      {
        "name": "signer",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": [
          "Authority with enhanced verification"
        ]
      },
      {
        "name": "compression_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "SPL Account Compression program"
        ],
        "address": "cmtDvXumGCrqC1Age74AVPhSRVXJMd8PJS91L8KbNCK"
      },
      {
        "name": "log_wrapper",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "SPL Noop program for logging"
        ],
        "address": "noopb9bkMVfRPU8AsbpTUg8AQkHtKwMYZiFUjNRtMmV"
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "System program for account creation"
        ],
        "address": "11111111111111111111111111111111"
      },
      {
        "name": "clock",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Clock sysvar for timestamps"
        ],
        "address": "SysvarC1ock11111111111111111111111111111111"
      }
    ],
    "docs": "Register Agent using ZK compression (solves error 2006 with 5000x cost reduction)",
    "discriminator": [
      15,
      6,
      94,
      55,
      65,
      80,
      123,
      248
    ],
    "args": [
      {
        "name": "agent_type",
        "type": "u8"
      },
      {
        "name": "metadata_uri",
        "type": "string"
      },
      {
        "name": "agent_id",
        "type": "string"
      },
      {
        "name": "name",
        "type": "string"
      },
      {
        "name": "description",
        "type": "string"
      },
      {
        "name": "pricing_model",
        "type": {
          "defined": {
            "name": "PricingModel"
          }
        }
      }
    ]
  },
  "register_ghost_metadata": {
    "name": "register_ghost_metadata",
    "expectedAccounts": [
      {
        "name": "agent_account",
        "pda": false
      },
      {
        "name": "authority",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "agent_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "authority",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": [
          "Anyone can add metadata to an Unregistered Ghost",
          "Claiming proves ownership later"
        ]
      }
    ],
    "docs": "Register metadata for an Unregistered Ghost  Adds name, description, capabilities, and service endpoint to a discovered Ghost. Transitions: Unregistered → Registered Anyone can add metadata to an Unregistered Ghost.  Parameters: - name: Agent name (max 64 chars) - description: Agent description (max 128 chars) - capabilities: List of capabilities (max 5) - service_endpoint: Optional HTTP endpoint for the agent service",
    "discriminator": [
      34,
      233,
      111,
      236,
      212,
      22,
      26,
      254
    ],
    "args": [
      {
        "name": "name",
        "type": "string"
      },
      {
        "name": "description",
        "type": "string"
      },
      {
        "name": "capabilities",
        "type": {
          "vec": "string"
        }
      },
      {
        "name": "service_endpoint",
        "type": {
          "option": "string"
        }
      }
    ]
  },
  "reset_reentrancy_guard": {
    "name": "reset_reentrancy_guard",
    "expectedAccounts": [
      {
        "name": "reentrancy_guard",
        "pda": true
      },
      {
        "name": "authority",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "reentrancy_guard",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                114,
                101,
                101,
                110,
                116,
                114,
                97,
                110,
                99,
                121,
                95,
                103,
                117,
                97,
                114,
                100
              ]
            }
          ]
        }
      },
      {
        "name": "authority",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      }
    ],
    "docs": "Reset a stuck reentrancy guard (admin only) Use this to recover from stuck states after failed transactions",
    "discriminator": [
      93,
      74,
      168,
      125,
      46,
      153,
      9,
      255
    ],
    "args": []
  },
  "resolve_did_document": {
    "name": "resolve_did_document",
    "expectedAccounts": [
      {
        "name": "did_document",
        "pda": true
      },
      {
        "name": "did_controller",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "did_document",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "DID document account"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                100,
                105,
                100,
                95,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116
              ]
            },
            {
              "kind": "account",
              "path": "did_controller"
            }
          ]
        }
      },
      {
        "name": "did_controller",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Controller public key (used for PDA derivation)"
        ]
      }
    ],
    "docs": "Resolve a DID document (read-only)  Returns the DID document data for off-chain resolution. This instruction exists for compatibility with standard DID resolution flows.",
    "discriminator": [
      168,
      180,
      218,
      211,
      184,
      19,
      102,
      12
    ],
    "args": []
  },
  "revoke_authorization": {
    "name": "revoke_authorization",
    "expectedAccounts": [
      {
        "name": "agent",
        "pda": false
      },
      {
        "name": "authorization",
        "pda": true
      },
      {
        "name": "authority",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "agent",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent revoking authorization"
        ]
      },
      {
        "name": "authorization",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Authorization account (PDA)"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                97,
                103,
                101,
                110,
                116,
                95,
                97,
                117,
                116,
                104
              ]
            },
            {
              "kind": "account",
              "path": "agent"
            },
            {
              "kind": "account",
              "path": "authorization.authorized_source",
              "account": "AgentReputationAuth"
            },
            {
              "kind": "arg",
              "path": "_nonce"
            }
          ]
        }
      },
      {
        "name": "authority",
        "writable": false,
        "signer": true,
        "optional": false,
        "docs": [
          "Authority (agent owner)"
        ]
      }
    ],
    "docs": "Revoke agent authorization  Allows an agent to revoke a previously granted authorization. Once revoked, the facilitator can no longer update reputation.  Parameters: - nonce: Optional nonce identifying the specific authorization to revoke",
    "discriminator": [
      222,
      179,
      207,
      59,
      191,
      78,
      24,
      248
    ],
    "args": [
      {
        "name": "nonce",
        "type": {
          "option": "string"
        }
      }
    ]
  },
  "revoke_credential": {
    "name": "revoke_credential",
    "expectedAccounts": [
      {
        "name": "credential",
        "pda": false
      },
      {
        "name": "issuer",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "credential",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "issuer",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      }
    ],
    "docs": "Revoke an issued credential Only the original issuer can revoke.",
    "discriminator": [
      38,
      123,
      95,
      95,
      223,
      158,
      169,
      87
    ],
    "args": []
  },
  "slash_stake": {
    "name": "slash_stake",
    "expectedAccounts": [
      {
        "name": "staking_account",
        "pda": true
      },
      {
        "name": "staking_config",
        "pda": true
      },
      {
        "name": "staking_vault",
        "pda": true
      },
      {
        "name": "treasury",
        "pda": false
      },
      {
        "name": "authority",
        "pda": false
      },
      {
        "name": "token_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "staking_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                115,
                116,
                97,
                107,
                105,
                110,
                103
              ]
            },
            {
              "kind": "arg",
              "path": "owner"
            }
          ]
        }
      },
      {
        "name": "staking_config",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                115,
                116,
                97,
                107,
                105,
                110,
                103,
                95,
                99,
                111,
                110,
                102,
                105,
                103
              ]
            }
          ]
        }
      },
      {
        "name": "staking_vault",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                115,
                116,
                97,
                107,
                105,
                110,
                103,
                95,
                118,
                97,
                117,
                108,
                116
              ]
            },
            {
              "kind": "account",
              "path": "staking_config"
            }
          ]
        }
      },
      {
        "name": "treasury",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "authority",
        "writable": false,
        "signer": true,
        "optional": false,
        "docs": []
      },
      {
        "name": "token_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
      }
    ],
    "docs": "Slash staked tokens (admin only, for fraud/disputes)",
    "discriminator": [
      190,
      242,
      137,
      27,
      41,
      18,
      233,
      37
    ],
    "args": [
      {
        "name": "owner",
        "type": "pubkey"
      },
      {
        "name": "reason",
        "type": {
          "defined": {
            "name": "SlashReason"
          }
        }
      },
      {
        "name": "custom_amount",
        "type": {
          "option": "u64"
        }
      }
    ]
  },
  "stake_ghost": {
    "name": "stake_ghost",
    "expectedAccounts": [
      {
        "name": "staking_account",
        "pda": true
      },
      {
        "name": "owner_token_account",
        "pda": false
      },
      {
        "name": "staking_vault",
        "pda": true
      },
      {
        "name": "staking_config",
        "pda": false
      },
      {
        "name": "ghost_mint",
        "pda": false
      },
      {
        "name": "owner",
        "pda": false
      },
      {
        "name": "token_program",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      },
      {
        "name": "rent",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "staking_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                115,
                116,
                97,
                107,
                105,
                110,
                103
              ]
            },
            {
              "kind": "account",
              "path": "owner"
            }
          ]
        }
      },
      {
        "name": "owner_token_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "staking_vault",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Staking vault to hold all staked GHOST tokens",
          "Automatically initialized on first stake using init_if_needed"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                115,
                116,
                97,
                107,
                105,
                110,
                103,
                95,
                118,
                97,
                117,
                108,
                116
              ]
            },
            {
              "kind": "account",
              "path": "staking_config"
            }
          ]
        }
      },
      {
        "name": "staking_config",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "ghost_mint",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "owner",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      },
      {
        "name": "token_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "11111111111111111111111111111111"
      },
      {
        "name": "rent",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "SysvarRent111111111111111111111111111111111"
      }
    ],
    "docs": "Stake GHOST tokens to boost agent reputation",
    "discriminator": [
      5,
      196,
      24,
      54,
      196,
      56,
      173,
      191
    ],
    "args": [
      {
        "name": "amount",
        "type": "u64"
      },
      {
        "name": "lock_duration",
        "type": "i64"
      }
    ]
  },
  "submit_delivery": {
    "name": "submit_delivery",
    "expectedAccounts": [
      {
        "name": "escrow",
        "pda": true
      },
      {
        "name": "agent",
        "pda": false
      },
      {
        "name": "agent_owner",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "escrow",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                103,
                104,
                111,
                115,
                116,
                95,
                112,
                114,
                111,
                116,
                101,
                99,
                116
              ]
            },
            {
              "kind": "account",
              "path": "escrow.client",
              "account": "GhostProtectEscrow"
            },
            {
              "kind": "account",
              "path": "escrow.escrow_id",
              "account": "GhostProtectEscrow"
            }
          ]
        }
      },
      {
        "name": "agent",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "agent_owner",
        "writable": false,
        "signer": true,
        "optional": false,
        "docs": []
      }
    ],
    "docs": "Agent submits work delivery proof",
    "discriminator": [
      217,
      177,
      33,
      54,
      136,
      185,
      123,
      96
    ],
    "args": [
      {
        "name": "delivery_proof",
        "type": "string"
      }
    ]
  },
  "submit_service_rating": {
    "name": "submit_service_rating",
    "expectedAccounts": [
      {
        "name": "reputation_metrics",
        "pda": true
      },
      {
        "name": "agent",
        "pda": false
      },
      {
        "name": "client",
        "pda": false
      },
      {
        "name": "clock",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "reputation_metrics",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Reputation metrics account"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                114,
                101,
                112,
                117,
                116,
                97,
                116,
                105,
                111,
                110,
                95,
                109,
                101,
                116,
                114,
                105,
                99,
                115
              ]
            },
            {
              "kind": "account",
              "path": "agent"
            }
          ]
        }
      },
      {
        "name": "agent",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent account"
        ]
      },
      {
        "name": "client",
        "writable": false,
        "signer": true,
        "optional": false,
        "docs": [
          "Client submitting the rating"
        ]
      },
      {
        "name": "clock",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Clock for timestamps"
        ],
        "address": "SysvarC1ock11111111111111111111111111111111"
      }
    ],
    "docs": "Submit a service rating after a completed transaction  Allows clients to rate agent service quality (1-5 scale). Ratings are factored into the overall reputation score calculation.  Parameters: - rating: Service rating from 1 (poor) to 5 (excellent) - payment_signature: Associated PayAI transaction signature",
    "discriminator": [
      23,
      160,
      228,
      88,
      168,
      145,
      129,
      19
    ],
    "args": [
      {
        "name": "rating",
        "type": "u8"
      },
      {
        "name": "payment_signature",
        "type": "string"
      }
    ]
  },
  "unstake_ghost": {
    "name": "unstake_ghost",
    "expectedAccounts": [
      {
        "name": "staking_account",
        "pda": true
      },
      {
        "name": "staking_config",
        "pda": true
      },
      {
        "name": "staking_vault",
        "pda": true
      },
      {
        "name": "owner_token_account",
        "pda": false
      },
      {
        "name": "owner",
        "pda": false
      },
      {
        "name": "token_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "staking_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                115,
                116,
                97,
                107,
                105,
                110,
                103
              ]
            },
            {
              "kind": "account",
              "path": "owner"
            }
          ]
        }
      },
      {
        "name": "staking_config",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                115,
                116,
                97,
                107,
                105,
                110,
                103,
                95,
                99,
                111,
                110,
                102,
                105,
                103
              ]
            }
          ]
        }
      },
      {
        "name": "staking_vault",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                115,
                116,
                97,
                107,
                105,
                110,
                103,
                95,
                118,
                97,
                117,
                108,
                116
              ]
            },
            {
              "kind": "account",
              "path": "staking_config"
            }
          ]
        }
      },
      {
        "name": "owner_token_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "owner",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      },
      {
        "name": "token_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [],
        "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
      }
    ],
    "docs": "Unstake GHOST tokens after lock period expires",
    "discriminator": [
      252,
      101,
      172,
      252,
      1,
      4,
      12,
      116
    ],
    "args": []
  },
  "update_agent": {
    "name": "update_agent",
    "expectedAccounts": [
      {
        "name": "agent_account",
        "pda": true
      },
      {
        "name": "signer",
        "pda": false
      },
      {
        "name": "clock",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "agent_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent account with canonical PDA validation"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                97,
                103,
                101,
                110,
                116
              ]
            },
            {
              "kind": "account",
              "path": "signer"
            },
            {
              "kind": "arg",
              "path": "agent_id"
            }
          ]
        }
      },
      {
        "name": "signer",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": [
          "Enhanced authority verification"
        ]
      },
      {
        "name": "clock",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Clock sysvar for rate limiting"
        ],
        "address": "SysvarC1ock11111111111111111111111111111111"
      }
    ],
    "docs": "",
    "discriminator": [
      85,
      2,
      178,
      9,
      119,
      139,
      102,
      164
    ],
    "args": [
      {
        "name": "_agent_type",
        "type": "u8"
      },
      {
        "name": "name",
        "type": {
          "option": "string"
        }
      },
      {
        "name": "description",
        "type": {
          "option": "string"
        }
      },
      {
        "name": "metadata_uri",
        "type": "string"
      },
      {
        "name": "_agent_id",
        "type": "string"
      },
      {
        "name": "pricing_model",
        "type": {
          "option": {
            "defined": {
              "name": "PricingModel"
            }
          }
        }
      }
    ]
  },
  "update_agent_reputation": {
    "name": "update_agent_reputation",
    "expectedAccounts": [
      {
        "name": "agent_account",
        "pda": true
      },
      {
        "name": "signer",
        "pda": false
      },
      {
        "name": "clock",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "agent_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent account with canonical PDA validation"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                97,
                103,
                101,
                110,
                116
              ]
            },
            {
              "kind": "account",
              "path": "signer"
            },
            {
              "kind": "arg",
              "path": "agent_id"
            }
          ]
        }
      },
      {
        "name": "signer",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": [
          "Enhanced authority verification"
        ]
      },
      {
        "name": "clock",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Clock sysvar for rate limiting"
        ],
        "address": "SysvarC1ock11111111111111111111111111111111"
      }
    ],
    "docs": "",
    "discriminator": [
      80,
      227,
      92,
      245,
      231,
      37,
      99,
      180
    ],
    "args": [
      {
        "name": "agent_id",
        "type": "string"
      },
      {
        "name": "reputation_score",
        "type": "u64"
      }
    ]
  },
  "update_agent_service": {
    "name": "update_agent_service",
    "expectedAccounts": [
      {
        "name": "agent",
        "pda": true
      },
      {
        "name": "owner",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "agent",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent account with enhanced 2025 security patterns"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                97,
                103,
                101,
                110,
                116
              ]
            },
            {
              "kind": "account",
              "path": "owner"
            }
          ]
        }
      },
      {
        "name": "owner",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": [
          "Owner must be signer for security (2025 pattern)"
        ]
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "System program for account operations"
        ],
        "address": "11111111111111111111111111111111"
      }
    ],
    "docs": "",
    "discriminator": [
      87,
      146,
      181,
      198,
      252,
      68,
      243,
      102
    ],
    "args": [
      {
        "name": "service_data",
        "type": {
          "defined": {
            "name": "AgentServiceData"
          }
        }
      }
    ]
  },
  "update_crosschain_status": {
    "name": "update_crosschain_status",
    "expectedAccounts": [
      {
        "name": "credential",
        "pda": false
      },
      {
        "name": "issuer",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "credential",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "issuer",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": []
      }
    ],
    "docs": "Update the cross-chain sync status after syncing to Crossmint",
    "discriminator": [
      22,
      167,
      59,
      238,
      22,
      231,
      239,
      146
    ],
    "args": [
      {
        "name": "crossmint_credential_id",
        "type": "string"
      },
      {
        "name": "status",
        "type": {
          "defined": {
            "name": "CrossChainStatus"
          }
        }
      }
    ]
  },
  "update_did_document": {
    "name": "update_did_document",
    "expectedAccounts": [
      {
        "name": "did_document",
        "pda": true
      },
      {
        "name": "controller",
        "pda": false
      },
      {
        "name": "clock",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "did_document",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "DID document account with canonical PDA validation"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                100,
                105,
                100,
                95,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116
              ]
            },
            {
              "kind": "account",
              "path": "controller"
            }
          ]
        }
      },
      {
        "name": "controller",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": [
          "Controller of the DID (must match document controller)"
        ]
      },
      {
        "name": "clock",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Clock sysvar for timestamp validation"
        ],
        "address": "SysvarC1ock11111111111111111111111111111111"
      }
    ],
    "docs": "Update an existing DID document  Add or remove verification methods and service endpoints. Only the controller can update the DID document.  Parameters: - add_verification_method: Optional verification method to add - remove_verification_method_id: Optional method ID to remove - add_service_endpoint: Optional service endpoint to add - remove_service_endpoint_id: Optional service ID to remove",
    "discriminator": [
      64,
      216,
      17,
      91,
      205,
      94,
      45,
      57
    ],
    "args": [
      {
        "name": "add_verification_method",
        "type": {
          "option": {
            "defined": {
              "name": "VerificationMethod"
            }
          }
        }
      },
      {
        "name": "remove_verification_method_id",
        "type": {
          "option": "string"
        }
      },
      {
        "name": "add_service_endpoint",
        "type": {
          "option": {
            "defined": {
              "name": "ServiceEndpoint"
            }
          }
        }
      },
      {
        "name": "remove_service_endpoint_id",
        "type": {
          "option": "string"
        }
      }
    ]
  },
  "update_ghost_score": {
    "name": "update_ghost_score",
    "expectedAccounts": [
      {
        "name": "agent_account",
        "pda": false
      },
      {
        "name": "authority",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "agent_account",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": []
      },
      {
        "name": "authority",
        "writable": false,
        "signer": true,
        "optional": false,
        "docs": [
          "Authority allowed to update scores (could be governance/oracle)"
        ]
      }
    ],
    "docs": "Update Ghost Score from off-chain calculation  Called by the reputation oracle/calculator service. Updates the weighted Ghost Score and optionally the reputation components.  Parameters: - new_score: New Ghost Score (0-1000) - components: Optional reputation component breakdown",
    "discriminator": [
      213,
      152,
      5,
      80,
      163,
      224,
      151,
      120
    ],
    "args": [
      {
        "name": "new_score",
        "type": "u64"
      },
      {
        "name": "components",
        "type": {
          "option": {
            "vec": {
              "defined": {
                "name": "ReputationComponent"
              }
            }
          }
        }
      }
    ]
  },
  "update_protocol_config": {
    "name": "update_protocol_config",
    "expectedAccounts": [
      {
        "name": "config",
        "pda": true
      },
      {
        "name": "authority",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "config",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                112,
                114,
                111,
                116,
                111,
                99,
                111,
                108,
                95,
                99,
                111,
                110,
                102,
                105,
                103
              ]
            }
          ]
        }
      },
      {
        "name": "authority",
        "writable": false,
        "signer": true,
        "optional": false,
        "docs": []
      }
    ],
    "docs": "Update protocol configuration parameters",
    "discriminator": [
      197,
      97,
      123,
      54,
      221,
      168,
      11,
      135
    ],
    "args": [
      {
        "name": "escrow_fee_bps",
        "type": {
          "option": "u16"
        }
      },
      {
        "name": "agent_registration_fee",
        "type": {
          "option": "u64"
        }
      },
      {
        "name": "listing_fee",
        "type": {
          "option": "u64"
        }
      },
      {
        "name": "dispute_fee_bps",
        "type": {
          "option": "u16"
        }
      },
      {
        "name": "fees_enabled",
        "type": {
          "option": "bool"
        }
      },
      {
        "name": "treasury",
        "type": {
          "option": "pubkey"
        }
      },
      {
        "name": "buyback_pool",
        "type": {
          "option": "pubkey"
        }
      },
      {
        "name": "moderator_pool",
        "type": {
          "option": "pubkey"
        }
      }
    ]
  },
  "update_reputation_tags": {
    "name": "update_reputation_tags",
    "expectedAccounts": [
      {
        "name": "reputation_metrics",
        "pda": true
      },
      {
        "name": "agent",
        "pda": false
      },
      {
        "name": "authority",
        "pda": false
      },
      {
        "name": "clock",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "reputation_metrics",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Reputation metrics account"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                114,
                101,
                112,
                117,
                116,
                97,
                116,
                105,
                111,
                110,
                95,
                109,
                101,
                116,
                114,
                105,
                99,
                115
              ]
            },
            {
              "kind": "account",
              "path": "agent"
            }
          ]
        }
      },
      {
        "name": "agent",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent account"
        ]
      },
      {
        "name": "authority",
        "writable": false,
        "signer": true,
        "optional": false,
        "docs": [
          "Authority (can be the agent owner or authorized updater)"
        ]
      },
      {
        "name": "clock",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Clock for timestamps"
        ],
        "address": "SysvarC1ock11111111111111111111111111111111"
      }
    ],
    "docs": "Update reputation tags for an agent  Adds or updates granular reputation tags with confidence scores. Tags are categorized into skill, behavior, and compliance tags. Each tag has a confidence score (0-10000 basis points) and evidence count.  Tag decay: Tags automatically decay at 10 bp/day and become stale after 90 days. This ensures reputation data stays current and reflects recent performance.  Parameters: - skill_tags: Skill tags to add (e.g., \"rust\", \"smart-contracts\") - max 20 - behavior_tags: Behavior tags (e.g., \"responsive\", \"reliable\") - max 20 - compliance_tags: Compliance tags (e.g., \"kyc-verified\") - max 10 - tag_scores: Tag scores with confidence and evidence - max 50",
    "discriminator": [
      206,
      96,
      254,
      186,
      129,
      180,
      103,
      198
    ],
    "args": [
      {
        "name": "skill_tags",
        "type": {
          "vec": "string"
        }
      },
      {
        "name": "behavior_tags",
        "type": {
          "vec": "string"
        }
      },
      {
        "name": "compliance_tags",
        "type": {
          "vec": "string"
        }
      },
      {
        "name": "tag_scores",
        "type": {
          "vec": {
            "defined": {
              "name": "TagScore"
            }
          }
        }
      }
    ]
  },
  "update_reputation_with_auth": {
    "name": "update_reputation_with_auth",
    "expectedAccounts": [
      {
        "name": "agent",
        "pda": false
      },
      {
        "name": "reputation_metrics",
        "pda": true
      },
      {
        "name": "authorization",
        "pda": true
      },
      {
        "name": "usage_record",
        "pda": true
      },
      {
        "name": "authorized_source",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      },
      {
        "name": "clock",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "agent",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent whose reputation is being updated"
        ]
      },
      {
        "name": "reputation_metrics",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent reputation metrics"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                114,
                101,
                112,
                117,
                116,
                97,
                116,
                105,
                111,
                110,
                95,
                109,
                101,
                116,
                114,
                105,
                99,
                115
              ]
            },
            {
              "kind": "account",
              "path": "agent"
            }
          ]
        }
      },
      {
        "name": "authorization",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Authorization account (PDA)"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                97,
                103,
                101,
                110,
                116,
                95,
                97,
                117,
                116,
                104
              ]
            },
            {
              "kind": "account",
              "path": "agent"
            },
            {
              "kind": "account",
              "path": "authorized_source"
            },
            {
              "kind": "arg",
              "path": "_nonce"
            }
          ]
        }
      },
      {
        "name": "usage_record",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Usage record account (optional, for audit trail)"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                97,
                117,
                116,
                104,
                95,
                117,
                115,
                97,
                103,
                101
              ]
            },
            {
              "kind": "account",
              "path": "authorization"
            },
            {
              "kind": "account",
              "path": "authorization.current_index",
              "account": "AgentReputationAuth"
            }
          ]
        }
      },
      {
        "name": "authorized_source",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": [
          "Authorized source (e.g., PayAI facilitator)"
        ]
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "System program"
        ],
        "address": "11111111111111111111111111111111"
      },
      {
        "name": "clock",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Clock for timestamps"
        ],
        "address": "SysvarC1ock11111111111111111111111111111111"
      }
    ],
    "docs": "Update agent reputation using authorization  Facilitators (e.g., PayAI) use this to update agent reputation using a pre-existing authorization from the agent.  Parameters: - reputation_change: Change to reputation score (can be positive or negative) - transaction_signature: Transaction signature for audit trail - metadata: Optional metadata about the reputation update - nonce: Optional nonce matching the authorization",
    "discriminator": [
      61,
      236,
      225,
      167,
      134,
      43,
      53,
      93
    ],
    "args": [
      {
        "name": "reputation_change",
        "type": "i64"
      },
      {
        "name": "transaction_signature",
        "type": "string"
      },
      {
        "name": "metadata",
        "type": {
          "option": "string"
        }
      },
      {
        "name": "nonce",
        "type": {
          "option": "string"
        }
      }
    ]
  },
  "update_source_reputation": {
    "name": "update_source_reputation",
    "expectedAccounts": [
      {
        "name": "reputation_metrics",
        "pda": true
      },
      {
        "name": "agent",
        "pda": false
      },
      {
        "name": "authority",
        "pda": false
      },
      {
        "name": "clock",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "reputation_metrics",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Reputation metrics account"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                114,
                101,
                112,
                117,
                116,
                97,
                116,
                105,
                111,
                110,
                95,
                109,
                101,
                116,
                114,
                105,
                99,
                115
              ]
            },
            {
              "kind": "account",
              "path": "agent"
            }
          ]
        }
      },
      {
        "name": "agent",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent account"
        ]
      },
      {
        "name": "authority",
        "writable": false,
        "signer": true,
        "optional": false,
        "docs": [
          "Authority (can be oracle, agent owner, or authorized updater)"
        ]
      },
      {
        "name": "clock",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Clock for timestamps"
        ],
        "address": "SysvarC1ock11111111111111111111111111111111"
      }
    ],
    "docs": "Update reputation from a specific source  Updates or adds a reputation score from an external source (e.g., GitHub, custom webhook). Automatically aggregates all sources and detects conflicts.  Parameters: - source_name: Source identifier (e.g., \"github\", \"custom-webhook\") - score: Reputation score from source (0-1000) - weight: Source weight in basis points (0-10000) - data_points: Number of metrics contributing to score - reliability: Source reliability in basis points (0-10000)",
    "discriminator": [
      161,
      240,
      255,
      69,
      130,
      227,
      71,
      123
    ],
    "args": [
      {
        "name": "source_name",
        "type": "string"
      },
      {
        "name": "score",
        "type": "u16"
      },
      {
        "name": "weight",
        "type": "u16"
      },
      {
        "name": "data_points",
        "type": "u32"
      },
      {
        "name": "reliability",
        "type": "u16"
      }
    ]
  },
  "verify_agent": {
    "name": "verify_agent",
    "expectedAccounts": [
      {
        "name": "agent_verification",
        "pda": true
      },
      {
        "name": "agent",
        "pda": false
      },
      {
        "name": "verifier",
        "pda": false
      },
      {
        "name": "system_program",
        "pda": false
      },
      {
        "name": "clock",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "agent_verification",
        "writable": true,
        "signer": false,
        "optional": false,
        "docs": [
          "Verification account with enhanced PDA security"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                97,
                103,
                101,
                110,
                116,
                95,
                118,
                101,
                114,
                105,
                102,
                105,
                99,
                97,
                116,
                105,
                111,
                110
              ]
            },
            {
              "kind": "account",
              "path": "agent"
            },
            {
              "kind": "account",
              "path": "verifier"
            }
          ]
        }
      },
      {
        "name": "agent",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent account being verified (enhanced validation)"
        ]
      },
      {
        "name": "verifier",
        "writable": true,
        "signer": true,
        "optional": false,
        "docs": [
          "Verifier authority with enhanced permissions"
        ]
      },
      {
        "name": "system_program",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "System program for account operations"
        ],
        "address": "11111111111111111111111111111111"
      },
      {
        "name": "clock",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Clock sysvar for timestamp validation"
        ],
        "address": "SysvarC1ock11111111111111111111111111111111"
      }
    ],
    "docs": "",
    "discriminator": [
      206,
      212,
      108,
      12,
      105,
      61,
      100,
      66
    ],
    "args": [
      {
        "name": "agent_pubkey",
        "type": "pubkey"
      },
      {
        "name": "service_endpoint",
        "type": "string"
      },
      {
        "name": "supported_capabilities",
        "type": {
          "vec": "u64"
        }
      },
      {
        "name": "verified_at",
        "type": "i64"
      }
    ]
  },
  "verify_authorization": {
    "name": "verify_authorization",
    "expectedAccounts": [
      {
        "name": "agent",
        "pda": false
      },
      {
        "name": "authorization",
        "pda": true
      },
      {
        "name": "clock",
        "pda": false
      }
    ],
    "accounts": [
      {
        "name": "agent",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Agent account"
        ]
      },
      {
        "name": "authorization",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Authorization account (PDA)"
        ],
        "pda": {
          "seeds": [
            {
              "kind": "const",
              "value": [
                97,
                103,
                101,
                110,
                116,
                95,
                97,
                117,
                116,
                104
              ]
            },
            {
              "kind": "account",
              "path": "agent"
            },
            {
              "kind": "account",
              "path": "authorization.authorized_source",
              "account": "AgentReputationAuth"
            },
            {
              "kind": "arg",
              "path": "_nonce"
            }
          ]
        }
      },
      {
        "name": "clock",
        "writable": false,
        "signer": false,
        "optional": false,
        "docs": [
          "Clock for timestamp validation"
        ],
        "address": "SysvarC1ock11111111111111111111111111111111"
      }
    ],
    "docs": "Verify agent authorization (view-only)  Checks if an authorization is valid and returns its status. This is a read-only instruction for verification purposes.  Parameters: - nonce: Optional nonce identifying the specific authorization to verify",
    "discriminator": [
      43,
      9,
      131,
      59,
      74,
      118,
      113,
      170
    ],
    "args": [
      {
        "name": "nonce",
        "type": {
          "option": "string"
        }
      }
    ]
  }
};
